import * as ReasonsActions from '../../../ng2/main/reasons/reasons.actions.ts';
import { authenticatedPatientSelector } from '../../selectors/patients-selectors.ts';

module.exports = {
  bindings: {
    reasons: '<',
  },
  controller: class ReasonsController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
      'LoadingService',
      'ProductService',
      '$timeout',
      'ReasonService',
      'ReasonsService',
    ];

    reasons = [];

    constructor(
      $ngRedux,
      $scope,
      $state,
      LoadingService,
      ProductService,
      $timeout,
      ReasonService,
      ReasonsService,
    ) {
      this.$scope = $scope;
      this.$ngRedux = $ngRedux;
      this.$state = $state;
      this.LoadingService = LoadingService;
      this.ProductService = ProductService;
      this.$timeout = $timeout;
      this.ReasonService = ReasonService;
      this.ReasonsService = ReasonsService;
    }

    $onInit() {
      const unsubscribe = this.$ngRedux.subscribe(() => {
        const state = this.$ngRedux.getState();

        this.authenticatedPatient = authenticatedPatientSelector(state);
        this.group = state.group;
        this.reasons = state.reasons.list;
        this.selectedReason = state.reasons.current;

        if (this.selectedReason) {
          if (this.selectedReason.allowConsecutiveAppointments && this.authenticatedPatient.children.length) {
            this.LoadingService.show();
            this.$timeout(() => {
              this.$state.go('patients.id.reasons.id.patients', { reasonId: this.selectedReason.id });
            }, 500);
          } else if (this.ProductService.isAvailable('PATIENT_FORMS') && this.selectedReason.form && this.selectedReason.form.questionsCount) {
            // If reason has form, redirect to that form
            this.LoadingService.show();
            this.$timeout(() => {
              this.$state.go('patients.id.reasons.id.form', {
                groupId: this.$state.params.groupId,
                reasonId: this.selectedReason.id,
              });
            }, 500);
          } else {
            this.LoadingService.show();
            // If reason doesn't have form, redirect to preferences page
            this.$timeout(() => {
              // There seems to be an issue when calling this without the timeout for first time patients,
              // it would apparently not have finished resolving the previous redirect and would never do this one
              // until the user would do a page refresh, and it would work afterwards
              this.$state.go('patients.id.reasons.id.preferences', { reasonId: this.selectedReason.id });
            }, 500);
          }
        }
      });

      this.$scope.$on('$destroy', unsubscribe);
    }

    next() {
      if (!this.selectedReason) {
        return;
      }

      if (this.selectedReason.allowConsecutiveAppointments && this.authenticatedPatient.children.length) {
        this.$state.go('patients.id.reasons.id.patients', { reasonId: this.selectedReason.id });
      } else if (this.ProductService.isAvailable('PATIENT_FORMS') && this.selectedReason.form && this.selectedReason.form.questionsCount) {
        this.$state.go('patients.id.reasons.id.form', { reasonId: this.selectedReason.id });
      } else if (this.ReasonsService.hasPreferences(this.selectedReason)) {
        this.$state.go('patients.id.reasons.id.preferences', { reasonId: this.selectedReason.id });
      } else {
        this.$state.go('patients.id.reasons.id.availabilities', { reasonId: this.selectedReason.id });
      }
    }

    isReasonUnaccessible(reason) {
      return this.ReasonService.isReasonUnaccessible(reason) || reason.prohibitedMessage;
    }

    setCurrentReason(reason) {
      this.$ngRedux.dispatch(new ReasonsActions.SetCurrentReason(reason));
    }

    get canContinue() {
      return !!this.selectedReason && !this.selectedReason.prohibitedMessage;
    }

    get hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }
  },
  template: `
    <section class="booking-page">
      <div class="content">
        <reasons-navigation [no-form]="true"></reasons-navigation>

        <div class="wrapper">
          <div class="contextual-notice -has-icon" ng-if="!$ctrl.reasons.length">
            <div class="icon -warning"></div>
            <p translate="preferences_page.warning.offerings" translate-values="{ phone: $ctrl.group.mainContactNumber }"></p>
          </div>

          <div ng-if="$ctrl.reasons.length">
            <h2 ng-if="!$ctrl.hasManitobaProduct" class="title -main" translate="preferences_page.titles.types"></h2>
            <h2 ng-if="$ctrl.hasManitobaProduct" class="title -main" translate="preferences_page.titles.location"></h2>

            <ul class="reasons-list">
              <li ng-repeat="reason in $ctrl.reasons track by $index" class="reason">
                <button
                  role="button"
                  ng-class="{'-selected' : $ctrl.selectedReason.id === reason.id}"
                  ng-click="$ctrl.setCurrentReason(reason)"
                  ng-disabled="$ctrl.isReasonUnaccessible(reason)">
                  <p>{{ reason.description }}</p>
                </button>
              </li>
            </ul>

            <div class="contextual-notice -has-icon" ng-if="$ctrl.selectedReason && $ctrl.selectedReason.prohibitedMessage">
              <div class="icon -warning"></div>
              <p>{{ $ctrl.selectedReason.prohibitedMessage }}</p>
            </div>

            <div class="actions">
              <button class="hollow-button" ui-sref="patients.id.home" translate="actions.btn_cancel"></button>
              <button class="button -next" ng-disabled="!$ctrl.canContinue" ng-click="$ctrl.next()" translate="actions.next"></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
};



// WEBPACK FOOTER //
// ./main/components/reasons/reasons.js